import { Component, AfterViewInit, ElementRef } from '@angular/core';
import 'slick-carousel';

@Component({
    selector: 'transf-infos',
    templateUrl: './transf-infos.component.html',
})

export class TransfInfos implements AfterViewInit {

    public element: any;
    public slideMainClass: string = '.cards-container--doubt';
    public popoverBancoCentralBrasil = `<div>         
        <div class='pop-title'>Banco Central do Brasil</div>
        <div class='pop-content'>
            O Banco Central do Brasil é a principal autoridade monetária do Brasil.` +
            `É responsável pela supervisão da política monetária e cambial do país e na fiscalização do sistema financeiro nacional.` +
        `</div>
    </div>`;

    constructor(
        elementRef: ElementRef,
    ) {
        this.element = $(elementRef.nativeElement);
    }

    public ngAfterViewInit() {

        // Slick
        function cardsHeight() {
            let height = 0;
            $('.card-item--doubt')
            .css('height', 'inherit');
            $('.card-item--doubt')
            .each(function() {
                if ($(this)
                .height() > height) {
                    height = $(this)
                    .height();
                }
            });
            $('.card-item--doubt')
            .css('height', height);
        }

        $('.cards-container--doubt')
        .on('init', (slick) => {
            cardsHeight();
        });

        // Start slide after DOM init
        this.element.find(this.slideMainClass)
        .slick({
            infinite: false,
            slidesToShow: 3,
            dots: false,
            edgeFriction: 1,
            responsive: [{
                breakpoint: 1023,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    dots: true,
                },
            }],
        });

        $( window )
        .resize(() => {
            cardsHeight();
        });
    }
}
